import React, { useState } from 'react';
import Sidebar from './../Sidebar/index';
import { IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Outlet } from 'react-router-dom'; // <--- necesario para rutas hijas

const MainLayout = () => {
  const [isSidebarVisible, setSidebarVisible] = useState(true);

  const toggleSidebar = () => {
    setSidebarVisible(!isSidebarVisible);
  };

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <Sidebar isVisible={isSidebarVisible} />
      <main
        style={{
          flexGrow: 1,
          padding: '1rem',
          transition: 'margin-left 0.3s',
          marginLeft: isSidebarVisible ? '0px' : '0',
          width: '100%',
          overflow: 'auto',
        }}
      >
        <IconButton
          onClick={toggleSidebar}
          sx={{ marginBottom: 2 }}
          style={{
            position: 'absolute',
            top: '1rem',
            left: isSidebarVisible ? '0px' : '1rem',
            transition: 'left 0.3s',
            zIndex: 1000,
          }}
        >
          <MenuIcon />
        </IconButton>

        {/* Aquí van las rutas hijas */}
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayout;
